import React, { useState, useEffect } from "react";
import WeatherForecastDay from "./WeatherForecastDay";
import "./WeatherForecast.css";
import axios from "axios";

export default function WeatherForecast(props) {
  let [loaded, setLoaded] = useState(false);
  let [forecast, setForecast] = useState(null);

  useEffect(() => {
    setLoaded(false);
  }, [props.coordinates]);

  function handleResponse(response) {
    setForecast(response.data.daily);
    setLoaded(true);
    console.log(response.data.daily);
  }
  if (loaded) {
    return (
      <div className="WeatherForecast">
        <div className="row">
          <div className="col" id="zeroDay">
            <WeatherForecastDay data={forecast[0]} />
          </div>
          <div className="col" id="firstDay">
            <WeatherForecastDay data={forecast[1]} />
          </div>
          <div className="col" id="secondDay">
            <WeatherForecastDay data={forecast[2]} />
          </div>
          <div className="col" id="thirdDay">
            <WeatherForecastDay data={forecast[3]} />
          </div>
          <div className="col" id="fourthdDay">
            <WeatherForecastDay data={forecast[4]} />
          </div>
        </div>
      </div>
    );
  } else {
    let apiKey = "88c09f696266983e1aafe60fe4c4f352";
    let longitude = props.coordinates.lon;
    let latitude = props.coordinates.lat;
    let apiUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=${latitude}&lon=${longitude}&appid=${apiKey}&units=metric`;

    axios.get(apiUrl).then(handleResponse);
    return null;
  }
}
